import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, QueryList, ViewChildren } from "@angular/core";
import { ProvisioningService } from "ng/src/app/log-settings/provisioning/provisioning.service";
import { LogBookLog } from "ng/src/app/logs/log.model";
import { PrimeTemplate } from "primeng/api";
import { Subject } from "rxjs";

@Component({
	selector: 'provisioning',
	templateUrl: 'provisioning.component.html',
	providers: [ProvisioningService]
})
export class Provisioning implements AfterViewInit, OnDestroy {
	@ViewChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
	
	@Input()
	set selectedLog(log: LogBookLog) {
		this.provisioningService.selectedLog.next(log);
	};
	
	selectedTemplate?: PrimeTemplate;
	options = new Array<PrimeTemplate>();
	
	private _onDestroy = new Subject<void>();
	
	constructor(
		public provisioningService: ProvisioningService,
		private changeRef: ChangeDetectorRef
	) {}
	
	ngAfterViewInit(): void {
		this.options = this.templates.toArray();
		this.changeRef.detectChanges();
	}
	
	ngOnDestroy(): void {
		this._onDestroy?.next();
	}
}